const DAYS = [["Mon", 0], ["Tue", 1], ["Wed", 2], ["Thu", 3], ["Fri", 4], ["Sat", 5], ["Sun", 6]];
const HOURS = Array.from({ length: 24 }, (_, h) => [h, `${((h + 11) % 12) + 1} ${h < 12 ? "am" : "pm"}`]);

// Days + hour (in the member's own time zone) for the briefing delivery.
export const SchedulePicker = ({ value, onChange, testid = "briefing" }) => {
  const tz = value.tz || Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  const toggle = (d) => onChange({ ...value, tz, days: value.days.includes(d) ? value.days.filter((x) => x !== d) : [...value.days, d].sort() });
  return (
    <div className="rounded-xl border border-border p-3 space-y-2" data-testid={`${testid}-schedule`}>
      <div className="text-xs text-muted-foreground">Deliver on</div>
      <div className="flex flex-wrap gap-1.5">
        {DAYS.map(([label, d]) => (
          <button key={d} type="button" data-testid={`${testid}-day-${d}`} aria-pressed={value.days.includes(d)} onClick={() => toggle(d)} className={`rounded-full px-2.5 py-1 text-xs border transition-colors ${value.days.includes(d) ? "bg-primary text-primary-foreground border-primary" : "border-border hover:border-primary"}`}>{label}</button>
        ))}
      </div>
      <label className="flex items-center justify-between gap-3 text-xs text-muted-foreground">around
        <select data-testid={`${testid}-hour`} value={value.hour} onChange={(e) => onChange({ ...value, tz, hour: Number(e.target.value) })} className="h-8 rounded-md border border-input bg-background px-2 text-sm text-foreground">{HOURS.map(([h, l]) => <option key={h} value={h}>{l}</option>)}</select>
        <span className="truncate" data-testid={`${testid}-tz`} title={tz}>{tz.replace(/_/g, " ")}</span>
      </label>
    </div>
  );
};
